export default "__VITE_ASSET__DPLkDISa__"